import script from "./GameHub.vue?vue&type=script&setup=true&lang=js"
export * from "./GameHub.vue?vue&type=script&setup=true&lang=js"

import "./GameHub.vue?vue&type=style&index=0&id=23d1bc36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23d1bc36"]])

export default __exports__